//Profile page
import React, { useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Button, Input, Text, Spacer, Loading, Modal } from '@nextui-org/react';
import { getAuth, signOut } from "firebase/auth";
import { toast } from 'react-toastify';
import { BsFillGearFill } from 'react-icons/bs';
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import { firestore } from '../config/firebase';
import Divider from '../Components/Divider';

const Profile = () => {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const handler = () => setVisible(true);
    const handlerDelete = () => setVisibleModalDelete(true);
    const [visible, setVisible] = useState(false);
    const [visibleModalDelete, setVisibleModalDelete] = useState(false);
    const [onEdit, setOnEdit] = useState(false);

    const navigate = useNavigate();
    const handleLogout = async () => {
        const auth = getAuth();
        signOut(auth).then(() => {
            navigate('/')
            toast.info("Vous êtes déconnecté.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                theme: "colored",
              })
        }).catch((error) => {
            console.log(error)
        });
    }

    useEffect(() => {
        //Fetch data user
        const fetchUser = async () => {
            const docRef = doc(firestore, "users", auth.currentUser.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setUser(docSnap.data())
                setLoading(false)
            } else {
                console.log("No such document!");
                setLoading(false)
            }
        }
        fetchUser()
    }, [])

    const deleteAccount = async () => {
        setLoadingDelete(true);
        try {
            const docRef = doc(firestore, "users", auth.currentUser.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                await auth.currentUser.delete();
                await deleteDoc(docRef);
                handleLogout();
                setLoadingDelete(false);
            } else {
                console.log("No such document!");
            }
        } catch (error) {
            if (error.code === 'auth/requires-recent-login') {
                toast.error("Vous devez vous reconnecter pour supprimer le compte.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    theme: "colored",
                })
                setLoadingDelete(false);
            } else {
                toast.error("Une erreur est survenue.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    theme: "colored",
                })
                setLoadingDelete(false);            
            }
        }
    }

    const closeHandler = () => {
        setVisible(false);
      };

      
    const closeHandlerDelete = () => {
        setVisible(false);
    };

    return (
        <Container css={{ shadow: '$lg', borderRadius: '$2xl', my: "$10", p: '$10', w: "680px"}} justify="center">
            {
                loading ?
                <Loading type='points' size='lg'/>
                :
                <>
                <Button color={'primary'} onClick={() => navigate('/dashboard')}>{"< Retour"}</Button>
                    <Row justify='center' align='center'>
                        <BsFillGearFill  color='#E91E63' size={"45"}/>
                        <Spacer x={0.5} />
                        <Text h1>Profile</Text>
                    </Row> 
                    <Text h2>Vos informations</Text>
                    <Spacer y={1} />
                    <Row justify='center' wrap="wrap">
                        <Input 
                        color='primary' 
                        bordered 
                        shadow 
                        labelPlaceholder='Prénom'
                        value={user?.firstname}
                        css={{m:"$5"}}>
                        </Input>
                        <Input
                            color='primary' 
                            bordered
                            shadow
                            labelPlaceholder='Nom'
                            value={user?.lastname}
                            css={{m:"$5"}}>
                        </Input>
                        <Input
                            color='primary'
                            bordered
                            shadow
                            labelPlaceholder='Email'
                            value={user?.email}
                            css={{m:"$5", mt: "$10"}}>
                        </Input>
                        {
                        !onEdit ?
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Input
                                color='primary'
                                bordered
                                shadow
                                labelPlaceholder="Nom d'expediteur"
                                value={user?.senderName}
                                css={{m:"$5", mt: "$10"}}
                                >
                            </Input>
                        </div>
                        :
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Input
                                color='primary'
                                bordered
                                shadow
                                labelPlaceholder="Nom d'expediteur"
                                value={user?.senderName}
                                css={{m:"$5", mt: "$10"}}
                                onChange={(e) => setUser({...user, senderName: e.target.value})}
                                contentEditable>
                            </Input>
                        </div>
                        }
                    </Row>
                    <Text h2>Statistiques</Text>
                    <Text h6>
                        Message(s) envoyé(s) : {user.smsCount ? user.smsCount : 0} 
                    </Text>
                    <Divider hp={5} color={"#E91E63"} marge={10} />
                    {/* Call to action */}
                    <Text h2>Actions</Text>
                    <Spacer y={2} />
                    <Row justify="center" wrap='wrap'>
                        <Button color={'error'} shadow onClick={handler}>Déconnexion</Button>
                        <Spacer x={2} />
                        <Button color={'warning'} shadow onClick={handlerDelete}>Supprimer le compte</Button>
                    </Row>
                    <Spacer y={2} />
                    <Text h6>
                        Version IT SMS: 1.1.4
                    </Text>
                </>
            }
            <Modal
                closeButton
                blur
                aria-labelledby="Deconnexion"
                open={visible}
                onClose={closeHandler}
                > 
                <Modal.Header>
                <Text id="modal-title" size={18}>
                    Voulez-vous vous déconnecter ?
                </Text>
                </Modal.Header>
                <Modal.Body>
                <Button auto color="warning" onPress={() => handleLogout()}>
                    Se déconnecter
                </Button>
                </Modal.Body>
            </Modal>
            <Modal
                closeButton
                blur
                aria-labelledby="Delete-account"
                open={visibleModalDelete}
                onClose={closeHandlerDelete}
                > 
                <Modal.Header>
                <Text b id="modal-title" size={18}>
                    Voulez-vous supprimer votre compte ?
                </Text>
                </Modal.Header>
                <Modal.Body>
                    <Text css={{textAlign: "center"}}>
                        Cette action est irréversible. Et le compte ne sera plus accessible.
                    </Text>
                    {
                        loadingDelete ?
                            <Loading type='points' size='lg' color={'error'}/>
                        :
                        <Button auto color="error" onPress={() => deleteAccount()}>
                            Confirmer
                        </Button>
                    }
                </Modal.Body>
            </Modal>
        </Container>
    )
}

export default Profile
